import { RibbonGroupBase } from '../ribbon-interfaces';
import { StylesHelper } from '../../helper/styles-helper';
import { SanitizeHtmlHelper, isNullOrUndefined } from '@syncfusion/ej2-base';
// Styles group constants
export const STYLES_GROUP_ID = '_styles_group';
/**
 * StylesGroup class for handling style operations in Document Editor ribbon
 * @private
 */
export class StylesGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon group model for Styles
     * @returns {RibbonGroupModel} - Ribbon group model
     * @private
     */
    getGroupModel() {
        const id = this.ribbonId;
        return {
            id: id + STYLES_GROUP_ID,
            cssClass: 'e-styles-group',
            header: this.localObj.getConstant('Styles'),
            enableGroupOverflow: true,
            keyTip: 'L',
            overflowHeader: this.localObj.getConstant('Styles'),
            groupIconCss: 'e-icons e-de-ctnr-paste',
            orientation: 'Row',
            showLauncherIcon: true,
            launcherIconKeyTip: 'FY',
            collections: [
                {
                    id: this.ribbonId + '_style-gallery',
                    items: [
                        {
                            type: 'Gallery',
                            gallerySettings: {
                                groups: [
                                    {
                                        header: this.localObj.getConstant('Styles'),
                                        items: this.getStyleItems()
                                    }
                                ],
                                itemCount: 3,
                                select: (args) => {
                                    if (!this.documentEditor.isReadOnly && this.documentEditor.editorModule) {
                                        const styleName = this.documentEditor.stylesDialogModule.getStyleName(SanitizeHtmlHelper.sanitize(args.currentItem.content));
                                        if (!isNullOrUndefined(this.documentEditor.documentHelper.styles.findByName(styleName))) {
                                            this.documentEditor.editorModule.applyStyle(styleName, true);
                                        }
                                    }
                                },
                                popupWidth: '150px',
                                popupHeight: '300px'
                            },
                            id: this.ribbonId + '_style-item-gallery',
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Styles') }
                        }
                    ]
                }
            ]
        };
    }
    getStyleItems() {
        return StylesHelper.getStyleItems(this.documentEditor, this.localObj);
    }
    // Update the updateStyleGallery method
    updateStyleGallery() {
        if (!this.container || !this.container.ribbon || !this.container.ribbon.ribbon) {
            return;
        }
        const galleryItem = this.container.ribbon.ribbon.getItem(this.ribbonId + '_style-item-gallery');
        if (!galleryItem || !galleryItem.gallerySettings || !galleryItem.gallerySettings.groups) {
            return;
        }
        const prevItemLength = galleryItem.gallerySettings.groups[0].items.length;
        // Update gallery items using the helper
        galleryItem.gallerySettings.groups[0].items = StylesHelper.getStyleItems(this.documentEditor, this.localObj);
        // Set the selected item based on current selection
        const currentStyle = StylesHelper.getCurrentStyleName(this.documentEditor, this.localObj);
        const prevSelectedItemIndex = galleryItem.gallerySettings.selectedItemIndex;
        galleryItem.gallerySettings.selectedItemIndex = StylesHelper.findStyleIndex(currentStyle, galleryItem.gallerySettings.groups[0].items);
        if (prevSelectedItemIndex !== galleryItem.gallerySettings.selectedItemIndex
            || prevItemLength !== galleryItem.gallerySettings.groups[0].items.length
            || (this.container.documentEditor && this.container.documentEditor.editorHistory
                && this.container.documentEditor.editorHistory.lastOperation
                && this.container.documentEditor.editorHistory.lastOperation.action === 'ModifyStyle')) {
            // Update the gallery
            this.container.ribbon.ribbon.updateItem(galleryItem);
        }
    }
}
